/**
 * В мини-аппе редактор выключал вертикальный свайп Telegram, чтобы жест по
 * холсту не сворачивал приложение. В браузере сворачивать нечего, заглушка.
 */
export function useDisableTmaSwipes() {}
